import type { App } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import PrimeVue from "primevue/config";
import { getPrimevueConfig } from "@allwyn/design-system/config/get-prime-vue-config";
import { IconAssets } from "@allwyn/design-system/src/icon/icon-assets";
import { pinia } from "@allwyn/utils/global-pinia";
import { queryClient } from "@allwyn/utils/global-vue-query-client";

/**
 * Installs shared plugins on a Vue app instance.
 *
 * All shared Vue apps on a page use the same Pinia instance,
 * so stores are shared between them.
 *
 * @param app - The Vue app instance to configure
 */
export function setupSharedApp(app: App): void {
    IconAssets.configure("/assets/icons");
    app.use(pinia);
    app.use(PrimeVue, getPrimevueConfig());
    app.use(VueQueryPlugin, { queryClient });
}
